import React, { useContext } from "react";
import { RiShieldCheckFill } from "@react-icons/all-files/ri/RiShieldCheckFill";
import { FaTimesCircle } from "@react-icons/all-files/fa/FaTimesCircle";
import { StoreContext } from "../../../context/context";
import { useTranslation } from "../../../context/TranslationContext";
import { getCookie } from "../ProductCategory";
import BackButton from "../../BackButton";

const Success = ({ isAppWebView }) => {
  const { page } = useContext(StoreContext);
  const {
    reservationSuccessPageTitle,
    reservationSuccessPageDescription,
    dear,
    reservationSuccessPageSuccessMessage,
    error,
    reservationSucessPageMailSendedMessage,
  } = useTranslation();
  let ShowReservationSucessPageMailSendedMessage = true;

  if (getCookie("user-link") == "1") {
    if (("," + getCookie("ids") + ",").indexOf("," + page?.evid + ",") > -1) {
      ShowReservationSucessPageMailSendedMessage = false;
    }
  }

  return (
    <div className="bg-brand-white bg-opacity-60 h-[calc(100vh-96px)] flex justify-center items-center px-4">
      <div className="w-full lg:w-1/2 bg-white rounded-lg px-4 py-10 flex items-center flex-col">
        <BackButton isAppWebView={isAppWebView} />
        {page.error ? (
          <>
            <FaTimesCircle size={96} className="text-red-500" />
            <span className="font-bold text-lg text-red-500 mt-2">{error}</span>
            <span className="text-sm text-brand-gray-2">{page.error}</span>
          </>
        ) : (
          <>
            <RiShieldCheckFill
              size={96}
              className="text-green-500"
            ></RiShieldCheckFill>
            <span className="font-bold text-lg text-green-500 mt-2">
              {reservationSuccessPageTitle}
            </span>
            <span
              className="text-sm text-brand-gray-2"
              dangerouslySetInnerHTML={{
                __html: reservationSuccessPageDescription.replace(
                  "{id}",
                  page.id,
                ),
              }}
            ></span>

            <hr className="h-0.25 bg-gray-100 w-full my-4"></hr>

            <p className="text-sm text-brand-gray text-center leading-6">
              {dear}{" "}
              <strong className="text-black font-extrabold">
                {page.musteri}
              </strong>
              <br></br>
              {reservationSuccessPageSuccessMessage}
              <br></br>
              {ShowReservationSucessPageMailSendedMessage && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: reservationSucessPageMailSendedMessage.replace(
                      "{mail}",
                      page.email,
                    ),
                  }}
                ></span>
              )}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Success;
